import type { PptSelectionMode } from "./ppt-audience-options";

export const PPT_SCENE_AUTO_VALUE = "__auto__";
export const PPT_SCENE_CUSTOM_VALUE = "__custom__";
export const PPT_SCENE_PRESETS = [
  "项目进度汇报",
  "项目验收/结项",
  "述职/工作总结",
  "项目立项/可行性",
  "融资路演",
  "解决方案/合作提案",
  "问题复盘/整改",
  "政务/国企工作汇报",
  "产品/运营复盘",
  "产品发布/渠道发布",
  "技术接入/资源评估",
  "技术测试/工程证据",
  "技术评估/实施计划",
  "研究/分析报告",
  "教学/培训课件",
  "产品/企业介绍",
  "财务/经营报告",
] as const;

export const PPT_SCENE_OPTIONS = [
  { value: PPT_SCENE_AUTO_VALUE, label: "自动判断" },
  ...PPT_SCENE_PRESETS.map((value) => ({ value, label: value })),
  { value: PPT_SCENE_CUSTOM_VALUE, label: "自定义" },
] as const;

export const DEFAULT_PPT_SCENE = "一般";

export function normalizePptSceneSelection(
  value: unknown,
  mode: unknown,
  customValue?: unknown,
): { mode: PptSelectionMode; scene: string; customScene: string } {
  const scene = typeof value === "string" ? value.trim().slice(0, 1_000) : "";
  const customScene = typeof customValue === "string" ? customValue.trim().slice(0, 1_000) : "";
  if (mode === "auto" || scene === PPT_SCENE_AUTO_VALUE) return { mode: "auto", scene: DEFAULT_PPT_SCENE, customScene: "" };
  if (mode === "custom" || scene === PPT_SCENE_CUSTOM_VALUE) {
    return { mode: "custom", scene: DEFAULT_PPT_SCENE, customScene: customScene || (scene === PPT_SCENE_CUSTOM_VALUE ? "" : scene) };
  }
  if (mode === "preset" || PPT_SCENE_PRESETS.includes(scene as (typeof PPT_SCENE_PRESETS)[number])) {
    return PPT_SCENE_PRESETS.includes(scene as (typeof PPT_SCENE_PRESETS)[number])
      ? { mode: "preset", scene, customScene: "" }
      : { mode: "auto", scene: DEFAULT_PPT_SCENE, customScene: "" };
  }
  // Legacy scenes are kept as custom text so old local drafts do not lose the
  // user's intent when migrating to the template-aligned list.
  return scene && scene !== DEFAULT_PPT_SCENE
    ? { mode: "custom", scene: DEFAULT_PPT_SCENE, customScene: scene }
    : { mode: "auto", scene: DEFAULT_PPT_SCENE, customScene: "" };
}

export function pptSceneSelectValue(mode: PptSelectionMode, scene: string): string {
  return mode === "auto" ? PPT_SCENE_AUTO_VALUE : mode === "custom" ? PPT_SCENE_CUSTOM_VALUE : scene;
}
